import type { Type, TemplateRef } from "@angular/core";

export type AiChatInputMode = "input" | "transcribe" | "processing";

export type ToolsMenuItem = {
  label: string;
} & (
  | {
      action: () => void;
      items?: never;
    }
  | {
      action?: never;
      items: (ToolsMenuItem | "-")[];
    }
);

export type AudioRecorderState = "idle" | "recording" | "processing";

export class AudioRecorderError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "AudioRecorderError";
  }
}

export interface AiChatTextareaProps {
  value?: string;
  placeholder?: string;
  maxRows?: number;
  autoFocus?: boolean;
  disabled?: boolean;
  onChange?: (value: string) => void;
  onKeyDown?: (event: KeyboardEvent) => void;
  inputClass?: string;
}

export interface AiChatButtonProps {
  disabled?: boolean;
  onClick?: () => void;
  inputClass?: string;
  type?: "button" | "submit" | "reset";
  ariaLabel?: string;
  title?: string;
}

export interface AiChatToolbarButtonProps extends AiChatButtonProps {
  icon?: TemplateRef<any>;
  tooltip?: string;
  variant?: "primary" | "secondary";
}

export interface AiChatToolsButtonProps extends AiChatButtonProps {
  toolsMenu?: (ToolsMenuItem | "-")[];
}

export interface AiChatAudioRecorderProps {
  inputClass?: string;
  onStateChange?: (state: AudioRecorderState) => void;
  showControls?: boolean;
}

export interface AiChatToolbarProps {
  inputClass?: string;
  position?: "top" | "bottom";
  alignment?: "left" | "center" | "right" | "space-between";
}

export interface AiChatInputConfig {
  mode?: AiChatInputMode;
  toolsMenu?: (ToolsMenuItem | "-")[];
  autoFocus?: boolean;
  additionalToolbarItems?: TemplateRef<any>;
  value?: string;
  class?: string;
}

export interface AiChatInputOutputs {
  submitMessage: (value: string) => void;
  startTranscribe: () => void;
  cancelTranscribe: () => void;
  finishTranscribe: () => void;
  addFile: () => void;
  changeValue: (value: string) => void;
}
